import { NOOP } from './constant';
export var isServerRendering = (function () {
    try {
        return !(typeof window !== 'undefined' && document !== undefined);
    }
    catch (e) {
        return true;
    }
})();
export var on = (function () {
    if (isServerRendering) {
        return NOOP;
    }
    return function (element, event, handler, capture) {
        element.addEventListener(event, handler, capture || false);
    };
})();
export var off = (function () {
    if (isServerRendering) {
        return NOOP;
    }
    return function (element, event, handler, capture) {
        element.removeEventListener(event, handler, capture || false);
    };
})();
export var contains = function (root, ele) {
    var node = ele;
    while (node) {
        if (node === root) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
};
